import type { FieldError, VolumeDetailsForms } from "./types";

// CardConnect rejects a zero average monthly volume / average ticket with an
// HTTP 409 (validation codes 9864 / 1131) -- the same gate IntakeForm applies
// merchant-side. Returns a FieldError for whichever is <= 0 (ids match the
// VolumeFields inputs), empty when both are fine. Callers apply it only when
// the application actually reaches CardConnect.
export function volumeTicketErrors(vol: VolumeDetailsForms): FieldError[] {
  const errs: FieldError[] = [];
  if (!(Number(vol.averageMonthlyVolume) > 0))
    errs.push({
      field: "averageMonthlyVolume",
      message: "Average monthly volume must be greater than 0.",
    });
  if (!(Number(vol.averageTicketAmount) > 0))
    errs.push({
      field: "averageTicketAmount",
      message: "Average ticket amount must be greater than 0.",
    });
  return errs;
}
